const KEYTYPES = [
  { 'id': 'front_door', 'title': 'Nøkler til inngangsdøren', 'value': 2, 'active': true },
  { 'id': 'mailbox', 'title': 'Nøkler til postkasse', 'value': 0, 'active': true },
  { 'id': 'power', 'title': 'Nøkler til strømskap', 'value': 0, 'active': false },
  { 'id': 'booth', 'title': 'Nøkler til bod', 'value': 0, 'active': false }
]
export default KEYTYPES;